import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';


@Injectable()
export class EventQueueService {

  private eventBrocker = new Subject<AppEvent<any>>();

  on(eventType: AppEventType): Observable<AppEvent<any>> {
    return this.eventBrocker.pipe(filter(event => event.type === eventType));
  }

  dispatch<T>(event: AppEvent<T>): void {
    this.eventBrocker.next(event);
  }

}

export enum AppEventType {
    LoginSuccess = 'LOGIN_SUCCESS',
    MyConfigLoaded = 'MY_CONFIG_LOADED',
    BusCheckinClearTabs = 'BUS_CHECKIN_CLEAR_TABS',
}

export class AppEvent<T> {
    constructor(
        public type: AppEventType,
        public payload: T,
    ) {}
}

//thanks to: https://medium.com/@Armandotrue/broadcasting-events-in-angular-b85289a4d685